import * as React from "react";
const SvgTankVessel = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 100, height: 70, viewBox: "0 0 100.0 70.0", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 100, height: 70, fill: "none", stroke: "currentColor", strokeWidth: 1 }));
export default SvgTankVessel;
